import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "suggest" }
const _hoisted_2 = {
  key: 0,
  class: "row muted"
}
const _hoisted_3 = {
  key: 1,
  class: "row muted"
}
const _hoisted_4 = { class: "pill-row" }
const _hoisted_5 = { class: "count" }

import { ref, watch } from 'vue';
import SearchService, { TypeaheadItem } from '@/services/SearchService';


export default /*@__PURE__*/_defineComponent({
  __name: 'SuggestList',
  props: {
    q: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const items = ref<TypeaheadItem[]>([]);
const loading = ref(false);
let t: ReturnType<typeof setTimeout> | null = null;
let inflight: AbortController | null = null;

function compact(n?: number) {
    if (typeof n !== 'number') return '';
    try {
        return Intl.NumberFormat(undefined, { notation: 'compact' }).format(n);
    } catch {
        return String(n);
    }
}

async function fetchNow(raw: string) {
    const q = raw.trim().toLowerCase();
    if (q.length < 2) {
        items.value = [];
        return;
    }

    inflight?.abort();
    inflight = new AbortController();
    loading.value = true;

    try {
        const resp = await SearchService.typeahead(q, 12, inflight.signal);
        // If the user typed "#dea", visually coerce to tag
        const forceKind: 'tag' | 'key' | null = q.startsWith('#') ? 'tag' : null;
        items.value = (resp.items ?? []).map((it) => ({
            kind: (forceKind ?? it.kind) as 'tag' | 'key',
            term: it.term,
            count: it.count,
            sample_thumb: it.sample_thumb,
            sample_route: it.sample_route,
        }));
    } catch {
        /* ignore abort/errors */
    } finally {
        if (!inflight?.signal.aborted) loading.value = false;
    }
}

watch(
    () => props.q,
    (val) => {
        if (t) clearTimeout(t);
        // immediate clear so UI doesn’t show stale chips while deleting
        if (!val || val.trim().length < 2) items.value = [];
        t = setTimeout(() => fetchNow(val), 150);
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Searching…"))
      : (!items.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No suggestions"))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (s) => {
        return (_openBlock(), _createBlock(_component_v_chip, {
          key: s.kind + ':' + s.term,
          color: s.kind === 'tag' ? 'primary' : 'secondary',
          variant: "elevated",
          class: "pill",
          onClick: ($event: any) => (emit('select', { type: s.kind, term: s.term }))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              (s.kind === 'tag')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("#" + _toDisplayString(s.term), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(s.term), 1)
                  ], 64)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(compact(s.count)), 1)
            ]),
            (s.sample_thumb)
              ? (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 0,
                  size: "20",
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: s.sample_thumb,
                      alt: "",
                      cover: ""
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["color", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})